import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/content";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 260, damping: 18 }}
      data-testid="floating-whatsapp-button"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a EcoJard no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_-8px_rgba(37,211,102,0.65)] transition-transform duration-200 hover:scale-105"
    >
      <span aria-hidden="true" className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-25" />
      <MessageCircle size={26} className="relative" />
    </motion.a>
  );
}
